const cleanSegment = (value) => String(value || '').trim();

const buildLabel = (city, region) => {
  const parts = [city, region]
    .map(cleanSegment)
    .filter((part) => part.length);
  return parts.length ? parts.join(', ') : '';
};

export const formatCoarseLocationLabel = (input) => {
  if (!input) return '';
  if (typeof input === 'string') {
    const parts = input
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean);
    return parts.slice(0, 2).join(', ');
  }

  const city =
    input.city || input.town || input.locality || input.place || null;
  const region =
    input.region || input.state || input.stateCode || input.state_code || null;
  const label = buildLabel(city, region);
  if (label) return label;

  const fallback =
    input.placeName ||
    input.place_name ||
    input.address ||
    input.description ||
    '';
  return formatCoarseLocationLabel(fallback);
};

export const getCoarseLocationLabel = (item) => {
  if (!item) return '';
  const metaLabel = item?.meta?.locationLabel || item?.meta?.location;
  if (metaLabel) return formatCoarseLocationLabel(metaLabel);

  const candidate =
    item.location ||
    item.originLocation ||
    item.destinationLocation ||
    item.lastKnownLocation ||
    item.lastLocation ||
    null;

  if (candidate) {
    if (typeof candidate === 'string') {
      return formatCoarseLocationLabel(candidate);
    }
    const label = buildLabel(
      candidate.city || candidate.town || candidate.locality || null,
      candidate.region || candidate.state || candidate.stateCode || candidate.state_code || null,
    );
    if (label) return label;
    const fallback =
      candidate.address ||
      candidate.description ||
      candidate.placeName ||
      candidate.place_name ||
      '';
    if (fallback) return formatCoarseLocationLabel(fallback);
  }

  const fallback =
    item.address || item.description || item.placeName || item.place_name || '';
  if (fallback) return formatCoarseLocationLabel(fallback);
  return '';
};
